import { trackEvent } from "./trackEvent"

export function trackAssetAction(
  action: string,
  source: string,
  token?: string
) {
  trackEvent("assets_action_clicked", {
    action,
    source,
    ...(token && { token }),
  })
}
